import React, { useEffect, useState, useRef } from 'react';
import { isMobile, isTablet } from "react-device-detect";
import contract from './redux/config/config.json';
import { Alchemy, Network } from 'alchemy-sdk';

const tokenContractABI = require('./token-abi.json');
const { createAlchemyWeb3 } = require('@alch/alchemy-web3');

var alch_network;
var alch_key;
var alchemyKey;
var contractAddress;
var tpx_address;

if (contract.NETWORK.ID == 1) {
  // Initialization
  alch_key = contract.ALCH_KEY;
  alch_network = Network.ETH_MAINNET;
  alchemyKey = contract.ALCH_KEY_LINK;
  contractAddress = String(contract.CONTRACT_ADDRESS);
  tpx_address = String(contract.TPX_ADDRESS);

}
if (contract.NETWORK.ID == 5) {
  // Initialization
  alch_key = contract.ALCH_KEY_TEST;
  alch_network = Network.ETH_GOERLI;
  alchemyKey = contract.ALCH_KEY_TEST_LINK;
  contractAddress = String(contract.CONTRACT_ADDRESS_GOERLI);
  tpx_address = String(contract.TPX_ADDRESS);
}

const alc_config = {
  apiKey: alch_key,
  network: alch_network,
};
const alchemy = new Alchemy(alc_config);
const alch_web3 = createAlchemyWeb3(alchemyKey);

const TokenProgress = ({ tokenId, tileClass }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [claimed, setClaimed] = useState(false); //toggle for claimed/unclaimed
    
      async function hasBeenClaimed(tokenId) {
          window.contract = await new alch_web3.eth.Contract(
            tokenContractABI,
            tpx_address
          );
          let claimed = await window.contract.methods
            .tokenClaimed(tokenId)
            .call();
          return claimed
      }

      useEffect(() => {
        // Define an async function inside the useEffect
        async function checkIfClaimed() {
          try {
            const claim = await hasBeenClaimed(tokenId);
            setClaimed(claim);
          } catch (error) {
            console.error('Failed to check if token has been claimed:', error);
            // Handle the error appropriately
            // For example, you might want to set 'claimed' to a default value or update the UI to show an error message
          }
        }

        // Call the async function
        checkIfClaimed();
      }, [tokenId, tileClass]); // Dependency array

      let class_multiplier = {
          'A': 4,
          'B': 3,
          'C': 2,
          'D': 1
      }

      let class_color = {
          'A': "#E97474",
          'B': "#F9E478",
          'C': "#78ACF9",
          'D': "#D3D3D3",
      }

    return (
        <div className='progress-display'
            style={
                isOpen ? (isMobile || isTablet ? { width: "min(69dvh, 69dvw)", height: "13%"} : { width: "min(49dvh, 49dvw)"})  : (isMobile || isTablet ? { width: 'min(13dvh, 13dvw)', height: "13%"} : { width: 'min(10dvh, 10dvw)' }) 
            }
            onMouseEnter={() => {
                setIsOpen(true);
            }}
            onMouseLeave={() => {
                setIsOpen(false)
            }}
            onClick={() => {
                setIsOpen(!isOpen);
            }}>
            <div className='icon-container'>
                <svg xmlns="http://www.w3.org/2000/svg" height="100%" viewBox="0 0 63 63" fill="none"
                    className={claimed ? "half-opacity" : null}>
                    <path d="M26.7402 8.58883V21.614H18.0334V25.9096H26.7402V32.0989H20.6593V35.1781H26.7402V46.6945L31.8537 51.96H44.0156V47.803L32.1301 46.4866L31.4086 35.1781H37.5508V32.0989H31.2121L30.8172 25.9096H39.6622V21.614H31.0245V8.58883H26.7402Z" fill="white" />
                    <defs>
                        <radialGradient id="paint0_radial_182_273" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(3 5.4634) rotate(43.4023) scale(68.9015 67.7974)">
                            <stop offset="0.322917" stopColor="#FEBE32" />
                            <stop offset="1" stopColor="#9C59EF" />
                        </radialGradient>
                    </defs>
                </svg>
            </div>
            <div className="progress-bar-wrapper" 
            style={
                isMobile || isTablet ? { width: "min(59dvh, 59dvw)"} : { width: "min(39dvh, 39dvw)"}
            }>
                <div className="progress-bar">
                    <span className={"top-text" + (claimed ? " half-opacity" : "")}
                        style={
                        isMobile || isTablet ? { fontSize: "12px"} : { fontSize: "min(2.5dvw, 2.5dvh)"}
                    }>
                        $TPX&nbsp;
                        {((class_multiplier[tileClass]) * ((Math.floor(tokenId / 10) * 10) * 0.001)).toFixed(2)}&nbsp;
                        <span style={claimed ? { color: "white" } : { color: "yellow" }}>
                            {claimed ? "CLAIMED" : "UNCLAIMED"}
                        </span>
                        <div className={"claim-indicator"}
                            style={{
                                opacity: claimed ? 0 : 1,
                                position: "absolute",
                                visibility: isOpen ? "hidden" : "visible",
                                backgroundColor: class_color[tileClass],
                                width: "10%",
                                height: "10%",
                                right: "min(1dvw, 1dvh)",
                              }}>
                        </div>
                    </span>
                    <div className={'class-icon' + (claimed ? " half-opacity" : "")}
                        style={
                            isMobile || isTablet ? { fontSize: "12px", color: class_color[tileClass], opacity: isOpen ? 1 : 0} : { fontSize: "min(2.5dvw, 2.5dvh)", color: class_color[tileClass], opacity: isOpen ? 1 : 0}
                        }>
                        {
                            <>
                                Class {tileClass} ×{class_multiplier[tileClass]}
                            </>
                        }
                    </div>
                </div>
            </div>
        </div >
    );
}

export default TokenProgress;


